export default "__VITE_ASSET__DWoYjjLD__"